import React, { useState } from "react"
import AddIcon from "@material-ui/icons/Add"
import Fab from "@material-ui/core/Fab"
import Zoom from "@material-ui/core/Zoom"

function CreateArea(props) {
  const [isExpanded, setExpanded] = useState(false)
  const [isDisabled, setDisabled] = useState(true)
  const [note, setNote] = useState({
    title: "",
    content: ""
  })

  function handleChange(event) {
    const { name, value } = event.target
    if (value === "" || note.title === "") {
      setDisabled(true)
    } else {
      setDisabled(false)
    }

    setNote(prevNote => {
      return {
        ...prevNote,
        [name]: value
      }
    })
  }
  const handleTitle = e => {
    const value = e.target.value
    if (value.trim() === "" || note.content === "") {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
    setNote(prevTitle => {
      return {
        title: value
      }
    })
  }
  const handleClick = () => {
    setExpanded(true)
  }
  // eslint-disable-next-line
  function expand() {
    setExpanded(true)
  }

  function submitNote(event) {
    props.onAdd(note)
    // console.log(note)
    setNote({
      title: "",
      content: ""
    })

    event.preventDefault()
  }

  return (
    <div>
      <form className="create-note col-12">
        {isExpanded && <input onChange={handleTitle} type="text" value={note.title} placeholder="Title" />}
        <textarea name="content" onClick={handleClick} onChange={handleChange} value={note.content} rows={isExpanded ? "3" : "1"} placeholder="Take a note..." />
        <Zoom in={isExpanded}>
          <Fab onClick={submitNote} disabled={isDisabled}>
            <AddIcon />
          </Fab>
        </Zoom>
      </form>
    </div>
  )
}

export default CreateArea
